import React from 'react';
import Script from 'next/script';
import { generateGoogleFrequentlyAskedQuestionsScript } from '../../helpers/google-faqs';
import { type FAQItem } from '../FAQ/FrequentlyAskedQuestions';

const GoogleFrequentlyAskedQuestionsScript = ({
  faqs,
}: {
  faqs: Array<FAQItem>;
}) => {
  if (!faqs || faqs.length === 0) {
    return null;
  }
  const generated = generateGoogleFrequentlyAskedQuestionsScript(faqs);
  if (!generated) {
    return null;
  }
  return (
    <Script type="application/ld+json" key="google-faq">
      {JSON.stringify(generated).replace(/(&quot;)/g, '"')}
    </Script>
  );
};

export default GoogleFrequentlyAskedQuestionsScript;
